import { motion, AnimatePresence } from 'framer-motion'
import { useEffect, useState } from 'react'
import './LevelUpModal.css'

export default function LevelUpModal({ level, xp, unlockedBadges = [], onClose }) {
  const [showConfetti, setShowConfetti] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowConfetti(false)
    }, 3000)

    return () => clearTimeout(timer)
  }, [])

  return (
    <AnimatePresence>
      <motion.div
        className="level-up-modal-overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
      >
        <motion.div
          className="level-up-modal"
          initial={{ scale: 0, rotate: -180 }}
          animate={{ scale: 1, rotate: 0 }}
          exit={{ scale: 0, rotate: 180 }}
          transition={{ type: 'spring', duration: 0.5 }}
          onClick={(e) => e.stopPropagation()}
        >
          {showConfetti && <div className="confetti-container">
            {[...Array(50)].map((_, i) => (
              <motion.div
                key={i}
                className="confetti"
                style={{
                  left: `${Math.random() * 100}%`,
                  backgroundColor: ['#E74C3C', '#2ECC71', '#F39C12'][Math.floor(Math.random() * 3)]
                }}
                initial={{ y: -20, opacity: 1 }}
                animate={{
                  y: 400,
                  x: (Math.random() - 0.5) * 200,
                  rotate: Math.random() * 360,
                  opacity: 0
                }}
                transition={{
                  duration: 2 + Math.random(),
                  ease: 'easeOut'
                }}
              />
            ))}
          </div>}

          <motion.div
            className="level-up-content"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            <div className="level-up-icon">🎉</div>
            <h1 className="level-up-title">LEVEL UP!</h1>
            <div className="level-up-badge">
              <span className="level-number">{level}</span>
            </div>
            <p className="level-up-text">
              You've reached Level {level}!
            </p>
            <p className="level-up-xp">Total XP: {xp}</p>

            {unlockedBadges.length > 0 && (
              <motion.div
                className="unlocked-badges"
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ delay: 0.5, type: 'spring' }}
              >
                <p className="badge-unlock-text">🎁 Badge Unlocked!</p>
                {unlockedBadges.map((badge, index) => (
                  <motion.div
                    key={badge.badge_id}
                    className="unlocked-badge"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.7 + index * 0.1 }}
                  >
                    <span className="badge-emoji">{badge.emoji}</span>
                    <span className="badge-name">{badge.name}</span>
                  </motion.div>
                ))}
              </motion.div>
            )}

            <motion.button
              className="btn btn-primary btn-large"
              onClick={onClose}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Awesome! 🚀
            </motion.button>
          </motion.div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  )
}
